import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Box from 'ui-box';
import { Button, useToast } from '../../npaper';
import { ISaleItem, ProductType, useStores } from '../../stores';
import { StatusBar } from '../purchase-orders';
import { TaskSideSheet } from '../tasks/TaskSideSheet';

export const SaleItemStatusCell = observer(
  ({ saleItem }: { saleItem: ISaleItem }) => {
    const { taskStore, saleItemStore } = useStores();
    const toaster = useToast();
    const intl = useIntl();
    const [inspectingTask, setInspectingTask] = useState(false);
    return (
      <>
        {saleItem.task && (
          <TaskSideSheet
            isShown={inspectingTask}
            onClose={() => setInspectingTask(false)}
            task={saleItem.task}
          />
        )}
        {saleItem.product && saleItem.product.type === ProductType.GOOD && (
          <Box display="flex" flexDirection="column" width="100%">
            {saleItem.quantity_reserved + saleItem.quantity_completed <
            saleItem.quantity ? (
              <div className="p small muted">
                {saleItem.quantity_reserved} af {saleItem.quantity}{' '}
                <FormattedMessage defaultMessage="reserved" />
              </div>
            ) : (
              <div className="p small muted">
                {saleItem.quantity_completed} af {saleItem.quantity}{' '}
                <FormattedMessage defaultMessage="done" />
              </div>
            )}
            <StatusBar
              success={saleItem.quantity_completed / saleItem.quantity}
              danger={
                (saleItem.quantity_completed + saleItem.quantity_missing) /
                saleItem.quantity
              }
            />
          </Box>
        )}
        {saleItem.task && (
          <Button small intent="info" onClick={() => setInspectingTask(true)}>
            <FormattedMessage defaultMessage="Show task" />
          </Button>
        )}
        {saleItem.product &&
          saleItem.product.type === ProductType.SERVICE &&
          !saleItem.task && (
            <Button
              small
              intent="info"
              primary
              onClick={() => {
                taskStore
                  .createItem({
                    sale_item: saleItem.id,
                  } as any) // We cast to any, as this is not entirely safe otherwise.
                  .then(() => saleItemStore.getItemWithQueue(saleItem.id, true))
                  .then(() => {
                    toaster.addToast({
                      message: intl.formatMessage({
                        defaultMessage: 'Task created successfully',
                      }),
                      intent: 'success',
                    });
                    setInspectingTask(true);
                  })
                  .catch(toaster.showDefaultError);
              }}
            >
              <FormattedMessage defaultMessage="Create task" />
            </Button>
          )}
      </>
    );
  }
);
